import * as React from 'react';
import { SelectChangeEvent } from '@mui/material';
import { Select } from 'components';
import { TProductsSortDropdown } from './ProductsSortDropdown.types';
import { PRODUCTS_SORT_OPTIONS } from './ProductsSortDropdown.constants';
import './ProductsSortDropdown.styled.scss';
import { useLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.provider';

const SORT_LABEL_KEYS: Record<string, string> = {
  default: 'products.sort.default',
  'name:asc': 'products.sort.name.asc',
  'name:desc': 'products.sort.name.desc',
  'price:asc': 'products.sort.price.asc',
  'price:desc': 'products.sort.price.desc',
};

export const ProductsSortDropdown: TProductsSortDropdown = ({
  onSortChange,
  defaultSortBy = 'default',
}) => {
  const localize = useLocalize();
  const [sortBy, setSortBy] = React.useState(defaultSortBy);

  const handleChange = (event: SelectChangeEvent) => {
    setSortBy(event.target.value);
    onSortChange(event.target.value);
  };

  return (
    <Select
      labelId="sort-select-label"
      id="sort-select"
      value={sortBy}
      label={localize('products.sort.label') as string}
      size="small"
      onChange={handleChange}
      minWidth="200px"
      maxWidth="100%"
      className="products-sort-dropdown__select"
      options={PRODUCTS_SORT_OPTIONS.map((option) => ({
        id: option.value,
        label: localize(
          SORT_LABEL_KEYS[option.value] ?? option.value
        ) as string,
      }))}
    />
  );
};
